import { Box, Button, Card, CardActions, CardContent, CardHeader, TextField, Tooltip } from "@mui/material";
import debounce from "lodash.debounce";
import { useMemo } from "react";
import { useNotesState } from "../State/NotesState";
import { AppFeatureLookup, defaultUnauthorizedMessage } from "../../../../App/Constants/AbacConstants";
import { useFeaturePermission } from "../../../../App/State/Hooks/abacHooks";

export default function AddNote() {
  const {
    getters: { isNoteValid, newNote, saveNoteLoading },
    handlers: { handleNoteChange, handleNoteSave },
  } = useNotesState();
  const debouncedNoteSaveHandler = useMemo(() => debounce(handleNoteSave, 300), [handleNoteSave]);
  const addNoteAccess = useFeaturePermission(AppFeatureLookup.ProfileAddCandidateNotes);
  return (
    <Card
      sx={{
        width: 1,
        mt: 3,
        boxShadow: "none",
        background: "transparent",
        p: 0,
      }}
      raised={false}
    >
      <CardHeader title="Add a new note" sx={{ px: 0 }} />
      <CardContent sx={{ px: 0 }}>
        <TextField
          id="addcandidatenote-textarea"
          label="Add Note"
          multiline
          rows={5}
          aria-label="addnote-textarea"
          data-test="addnote-textarea"
          sx={{
            width: 1,
            px: 0,
            ".MuiOutlinedInput-root": { background: "white" },
          }}
          onChange={handleNoteChange}
          error={!isNoteValid}
          helperText={`${newNote.length}/1500`}
          value={newNote}
          disabled={!addNoteAccess}
        />
      </CardContent>
      <CardActions sx={{ p: 0, justifyContent: "flex-end" }}>
        <Tooltip title={addNoteAccess ? "Save Candidate Note" : defaultUnauthorizedMessage}>
          <Box>
            <Button
              aria-label="Save Candidate Note"
              type="submit"
              variant="contained"
              color="primary"
              onClick={addNoteAccess ? debouncedNoteSaveHandler : undefined}
              data-test="addnote-save-button"
              disabled={!addNoteAccess || !isNoteValid || saveNoteLoading}
            >
              Add Note
            </Button>
          </Box>
        </Tooltip>
      </CardActions>
    </Card>
  );
}
